import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: 20, 
    },
    paper: {
        height: 140,
        width: 100,
    },
    control: {
        padding: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
}));

export default function ChronTab(props) {
    const [pause, setPause] = useState(false)
    const classes = useStyles();

    const togglePause = () => {
        console.log(pause)
        pause ? setPause(false) : setPause(true)
    }

    return (
    <div>
    <Paper style={{ padding: 20 }}>
            <Button
                variant="outlined"
                color="secondary"
                color={pause ? 'primary' : 'secondary'}
                startIcon={pause ? <PlayCircleOutlineIcon fontSize="large" /> : <PauseCircleOutlineIcon fontSize="large" />}
                onClick={togglePause}
            >
                Chron jobs are {pause ? 'active' : 'paused'}.
      </Button>
            <div>
                <Grid container className={classes.root} spacing={2}>
                    <Grid item xs={4}>
                        <h4>Interval:</h4>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                            <InputLabel id="demo-simple-select-label">
                                Cadence
                            </InputLabel>
                            <Select
                                id="demo-simple-select"
                            //   onChange={handleChange}
                            >
                                <MenuItem value={10}>Daily</MenuItem>
                                <MenuItem value={20}>Weekly</MenuItem>
                                <MenuItem value={30}>Monthly</MenuItem>
                            </Select>
                        </FormControl>

                    </Grid>
                    <Grid item xs={4}>
                        <FormControl>

                            <TextField
                                id="time"
                                label="Time"
                                type="time"
                                defaultValue="08:00"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    step: 300, // 5 min
                                }}
                            />
                        </FormControl>

                    </Grid>
                </Grid>
            </div>
        </Paper>
        <Paper>
            <h2>Logs</h2>
        </Paper>
    </div>
    )
}